import {Dispatch} from 'redux';
import {beMatchLiveDataToMatchLiveData} from '../../../API/utils';
import {LIVE_MATCH_SCORE_GET_INVALIDATE, LIVE_MATCH_SCORE_GET_REQUEST, LIVE_MATCH_SCORE_GET_RESPONSE} from '../../actionTypes';
import {LiveMatchScoreGetInvalidateAction, LiveMatchScoreGetRequestAction, LiveMatchScoreGetResponseAction} from '../types';
import {getLiveMatchScoreById as fetchLiveMatchScoreById} from '../../../API/sportEvents';
import {MatchLiveData} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';
import {parseMatchDate} from '../../../utils/matchFns';

/**
 * Action creator for the get request of a live event score
 * @param id
 */
const getLiveMatchScoreGetRequest = (id: string): LiveMatchScoreGetRequestAction => ({
  type: LIVE_MATCH_SCORE_GET_REQUEST,
  payload: id,
});

/**
 * Action creator for the get response of a live event score
 */
const getLiveMatchScoreGetResponse = (liveData: MatchLiveData, matchDate: string): LiveMatchScoreGetResponseAction => ({
  type: LIVE_MATCH_SCORE_GET_RESPONSE,
  payload: {liveData, matchDate: parseMatchDate(matchDate)},
});

/**
 * Action creator for the get invalidation of a live event score
 * @param error
 */
const getLiveMatchScoreGetInvalidate = (error: Error): LiveMatchScoreGetInvalidateAction => ({
  type: LIVE_MATCH_SCORE_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * // BIQ: merge this action with getMatchLiveDataById, they're quite the same action
 */
const getLiveMatchScoreById = (id: string, date: string) => (dispatch: Dispatch): Promise<any> => {
  dispatch(getLiveMatchScoreGetRequest(id));

  return fetchLiveMatchScoreById(id)
    .then(beMatchLiveDataToMatchLiveData)
    .then((liveData: MatchLiveData) => dispatch(getLiveMatchScoreGetResponse(liveData, date)))
    .catch((error: Error) => dispatch(getLiveMatchScoreGetInvalidate(error)));
};

export default getLiveMatchScoreById;
